import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const TASK_LISTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('TASK_LISTS');
export const TASK_LISTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	TASK_LISTS_CRUD_ACTION_CONSTANTS
);
